import { html } from '@shared/utils/rendering/html';

const StaticDocumentation = () => {
    return html`
        <div class="mt-3">
            <h3>Risk Data Aggregation and Risk Reporting</h3>
            <${Purpose} />
            <${Background} />
            <${Objective} />
            <${Audience} />
        </div>
    `;
};

export default StaticDocumentation;

const Purpose = () => {
    return html`
        <h4>Purpose</h4>
        <p>
            The Purpose of this document is to provide those responsible and accountable with Risk
            Data Aggregation and Risk Reporting Compliance with an implementation guide to maintain
            BCBS 239 compliance, whilst rationalising attestation type procedures and standardising
            the application of RDARR in a business-as-usual context.
        </p>
    `;
};

const Background = () => {
    return html`
        <h4>Background</h4>
        <p>
            The Basel Committee on Banking Supervision’s Standard, “Principles for Effective Risk
            Data Aggregation and Risk Reporting” , commonly referred to as BCBS 239 or RDARR, set
            out the principles for effective risk data aggregation and risk reporting. Established
            in response to the 2008 financial crisis, this regulatory framework has aimed to
            strengthen banks risk management practise by enhancing he accuracy, completed,
            timeliness and adaptability of risk data. BCBS 239 compliance is critical for banks to
            improve decision making, risk management and regulatory processes.
        </p>
        <p>
            The Prudential Authority (PA) adopted the principles and recommended that they should be
            applied to all banks operating in South Africa and apply not only at a group level
            (controlling company consolidated), but also to all material business units or entities
            within the group. The required domestically systemic important banks (D-SIBS) in South
            Africa launched the required RDARR programmes to achieves the level of compliance as set
            out by the SARB. The SBG RDARR Programme completed its’ final year of implementation in
            2021 and transitioned to business-as-usual (BAU) as from 1 January 2022. Upon project
            completion of the RDARR project, handovers were conducted in terms of Group Risk,
            Business Units (BU’s), Segments, Africa Region entities and others where relevant to
            mark the commencement of absorbing project roles and responsibilities into respective
            “run the bank areas” per Business Unit, Segment and Africa Region (AR).
        </p>
    `;
};

const Objective = () => {
    return html`
        <h4>Objective</h4>
        <p>
            As it has now been several years since banks have been required to be BCBS 239 compliant
            and more focus is now on proving the embedment of BCBS 239 within the day-to-day
            practises of organisations, whilst maintaining the full level of compliance that has
            come to be expected by the Regulator and Internal Audit. Transitioning from
            attestation-based to evidence-based compliance strengthens governance and control.
        </p>
        <p>
            The basis for this evidenced based compliance is the Group Policies, Standards and
            Frameworks. The measurement of compliance should be consistently applied and measurable
            in the same.
        </p>
    `;
};

const Audience = () => {
    return html`
        <h4>Audience</h4>
        <p>
            This RDARR Re-Imagined model is aimed at those responsible and accountable for RDARR
            compliance such as the RDARR Sponsor - Head of Risk & Corporate Affairs / Chief Risk
            Officer at a Group Level. Overall accountability for compliance with BCBS 239 within a
            particular legal entity: Ensures RDARR oversight and implementation. RDARR Champion:
            Overall responsibility for the management and coordination of RDARR within a particular
            legal entity, and single line of communication with RDARR Central Office / Group Risk to
            ensure alignment of all legal entity compliance queries, processes and day to day
            functions.
        </p>
        <p>
            This includes Business Units – CIB, PPB, BCB, Non-Financial Risk and Legal entities -
            Angola, Botswana, Eswatini, Ghana, Kenya, Lesotho, Malawi, Mauritius, Mozambique,
            Namibia, Nigeria, Tanzania, Uganda, Zambia , Zimbabwe.
        </p>
    `;
};
